var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import getServiceAssetSchemas from '../../requests/service/getServiceAssetSchemas';
/**
 *
 */
var GetServiceAssetSchemasCommand = /** @class */ (function (_super) {
    __extends(GetServiceAssetSchemasCommand, _super);
    function GetServiceAssetSchemasCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param organisation OrginastionModel
     * @param assetModel AssetModel
     * @param serviceAssetSchemaCollection ServiceAssetSchemaCollection
     * @return {*}
     */
    GetServiceAssetSchemasCommand.prototype.execute = function (organisation, assetModel, serviceAssetSchemaCollection) {
        this.serviceAssetSchemaCollection = serviceAssetSchemaCollection;
        var promise = getServiceAssetSchemas(organisation, assetModel);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    GetServiceAssetSchemasCommand.prototype.then = function (response) {
        this.serviceAssetSchemaCollection.reset();
        try {
            this.serviceAssetSchemaCollection.addAll(response);
        }
        catch (e) {
            console.log(e);
        }
    };
    return GetServiceAssetSchemasCommand;
}(Command));
export default GetServiceAssetSchemasCommand;
